import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SubscriptionPlansService } from 'src/app/modules/home/services/subscription-plans.service';
import { SignupPlanPaymentsComponent } from 'src/app/modules/sign-up/components/signup-plan-payments/signup-plan-payments.component';
import { LoginData } from '../models/login-data';

@Injectable({
  providedIn: 'root'
})
export class PaymentModalService {
  private subPlanDetails: any;
  private userPrice: string;
  private priceEx: string;

  constructor(
    private dialog: MatDialog,
    private subscriptionPlansService: SubscriptionPlansService,
  ) {}

  openUpdateCardModalFromPlans(loginDetails: LoginData): void {
    this.subscriptionPlansService
      .getSubPlanById(loginDetails.plan_id ? loginDetails.plan_id : loginDetails.subscription_id)
      .subscribe(data => {
        this.subPlanDetails = data;
        if (this.subPlanDetails && this.subPlanDetails.monthy_price > 0) {
          this.userPrice = localStorage.getItem('selPrice');
          this.priceEx = localStorage.getItem('disValue');

          this.dialog.open(SignupPlanPaymentsComponent, {
            width: '30%',
            panelClass: ['custom-modal', 'animate__animated', 'animate__fadeInDown'],
            disableClose: true,
            data: {
              leadId: loginDetails.id,
              planDetails: this.subPlanDetails,
              type: "addcard"
            }
          });
        } else {
          console.log("Free plan detected → no popup opened.");
        }
      });
  }
}
